import React from "react";
import Fallback from "../../components/Fallback";

const ManageLayout = React.lazy(() => import("./ManageLayout"));
const Agents = React.lazy(() => import("./agents/Agents"));

const Analytics = React.lazy(() => import("./analytics/Analytics"));

const ApiKey = React.lazy(() => import("./api-key/ApiKey"));

const BillingUsages = React.lazy(() => import("./billing-usage/BillingUsages"));

const CannedMessage = React.lazy(
  () => import("./canned-message/CannedMessage")
);

const LiveChatSetting = React.lazy(
  () => import("./live-chat-setting/LiveChatSetting")
);

const NotificationPreferences = React.lazy(
  () => import("./notification-preferences/NotificationPreferences")
);

const OptinManagement = React.lazy(
  () => import("./optin-management/OptinManagement")
);

const Tags = React.lazy(() => import("./tags/Tags"));

const TemplateMessage = React.lazy(
  () => import("./template-message/TemplateMessage")
);

const CreateTemplateMessage = React.lazy(
  () => import("./template-message/CreateTemplateMessage")
);

const UserAttributes = React.lazy(
  () => import("./user-attributes/UserAttributes")
);
export const ManageLayoutScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <ManageLayout {...props} />
  </React.Suspense>
);
export const AgentsScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Agents {...props} />
  </React.Suspense>
);
export const AnalyticsScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Analytics {...props} />
  </React.Suspense>
);
export const ApiKeyScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <ApiKey {...props} />
  </React.Suspense>
);
export const BillingUsagesScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <BillingUsages {...props} />
  </React.Suspense>
);
export const CannedMessageScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <CannedMessage {...props} />
  </React.Suspense>
);
export const LiveChatSettingScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <LiveChatSetting {...props} />
  </React.Suspense>
);
export const NotificationPreferencesScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <NotificationPreferences {...props} />
  </React.Suspense>
);
export const OptinManagementScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <OptinManagement {...props} />
  </React.Suspense>
);
export const TagsScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Tags {...props} />
  </React.Suspense>
);
export const TemplateMessageScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <TemplateMessage {...props} />
  </React.Suspense>
);
export const CreateTemplateScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <CreateTemplateMessage {...props} />
  </React.Suspense>
);
export const UserAttributesScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <UserAttributes {...props} />
  </React.Suspense>
);
